import { useMedia } from 'react-use';
import { useTranslations } from 'next-intl';
import { SliderCard as SliderCardType } from '@silvertours/back-domain-page';
import { Carousel, SliderCard } from '@silvertours/front-entities';
import { Theme } from '@silvertours/front-shared';
import { Container, Wrapper } from './MarketingSlider.styles';

export type Props = {
  sliderCards?: SliderCardType[];
};

const MarketingSlider = ({ sliderCards }: Props) => {
  const CarouselContainer = Container;
  const t = useTranslations('features.marketingSlider');
  const isMobile = useMedia(
    `(max-width: ${Theme.getBreakpoint('xl')}px)`,
    true,
  );

  const isSmall = useMedia(`(max-width: ${Theme.getBreakpoint('sm')}px)`, true);

  const visibleItemsAmount = isMobile ? 1 : 3;

  if (!sliderCards?.length) {
    return null;
  }

  return (
    <Wrapper id="cardsSlider">
      <CarouselContainer
        as={Carousel}
        hasItemsToReveal={sliderCards.length > visibleItemsAmount}
        showSlideBackground={false}
        prevText={t('prevText')}
        nextText={t('nextText')}
        label={t('title')}
      >
        {sliderCards.map(card => (
          <SliderCard
            key={card.title}
            text={card.text}
            image={card.image}
            linkText={card.linkText}
            linkHref={card.href}
            isSmall={isSmall}
            title={card.title}
          />
        ))}
      </CarouselContainer>
    </Wrapper>
  );
};

export { MarketingSlider };
